import { Wording } from '@/types';

export const MEDITATION_WORDING_EE: Wording = {
  components_header_media_content: 'Helid',
  components_header_media_1: 'Meditatsioonid',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Juhendid',
  components_header_text2: 'Blogi',
  components_header_members: 'liikmed',
  hero_text: 'Kus meditatsioon kohtub tähtedega',
  hero_button_text: 'Alustage oma teekonda sissepoole',
  components_ressources_section_title: 'VAHENDID',
  components_ressources_subheader_text: 'Tööriistad sisemise rahu, maandamise ja igapäevase tasakaalu saavutamiseks',
  components_ressources_span_text: 'Avage uks sisemise rahu poole meie valitud meditatsioonide ja juhenditega. Leidke selgus, taasühendage oma hingamisega ja joonduge oma sisemise rütmiga – üks tähelepanelik hetk korraga.',
  components_ressources_card_1_title: 'Peegeldus',
  components_ressources_card_1_text: 'Lühikesed meditatsioonid ja helipeegeldused teie mõtete tsentreerimiseks ja kosmilise rütmiga kohanemiseks.',
  components_ressources_card_2_title: 'Uurige sügavusi',
  components_ressources_card_2_text: 'Reisige pinnast kaugemale koos ümbritsevate juhenditega, mis ühendavad meditatsiooni, astroloogiat ja eneseuuringuid püsivaks muutumiseks.',
  components_ressources_link: 'Vaata rohkem',
  components_notes_and_google_title_1: 'Hingeline juhendamine',
  components_notes_and_google_title_2: 'Teadlikud rituaalid',
  components_notes_and_google_title_3: 'Juhitud meditatsioonid',
  components_review_google_text: 'Google\'i ülevaated',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Meie meditatsioonid',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Avastage rohkem',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'JUHENDID',
  components_text1_subheader_text: 'Kosmilised teadmised igapäevaseks joondamiseks',
  components_text1_span_text: 'Joondage universumi rütmidega: avastage kureeritud põhjalike astroloogiliste ja meditatiivsete juhendite kogu, mis on loodud sisemise selguse äratamiseks, eneseteadvuse süvendamiseks ja teie hingelise ja taevase kasvu teekonna toetamiseks.',
  components_text1_card_1_title: 'Avatud vaiksele',
  components_text1_card_1_text: 'Alustage oma teekonda põhiliste meditatsiooni- ja astroloogiajuhistega – see sobib ideaalselt otsijatele, keda tõmbab sisemine vaikus, kosmilised mustrid ja isiklik arusaam.',
  components_text1_card_3_title: 'Vaimu-keha link',
  components_text1_card_3_text: 'Avasta oma sisemaailma sügavamad kihid. Need juhised liiguvad pinnast kaugemale, et paljastada tähendus, emotsioonid ja tähelepanelikud mustrid, mis kujundavad teie kogemust.',
  components_text1_card_2_title: 'Peegelda ja integreeri',
  components_text1_card_2_text: 'Emotsionaalsetest plokkidest planeetide tsükliteni – need juhendid pakuvad tööriistu järelemõtlemiseks, tervendamiseks ja ümberkujundamiseks teadlike rituaalide ja astroloogilise tarkuse kaudu.',
  components_text1_link: 'Kuva kõik juhendid',
  components_footer_text: 'Ärka üles: teie vaikus, teie tugevus',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreerimisnumber',
  components_footer_legal: 'Juriidiline',
  components_footer_terms: 'Tingimused',
  components_footer_privacy: 'Privaatsuspoliitika',
  button_load_more: 'Laadige rohkem',
  page_media_1_content_hero_text: 'Meditatsioonid',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energia Boost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Juhendid',
  page_text1_section_title: 'Juhendid',
  page_text1_subheader_text: 'Meie teejuhid',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Jätkamiseks sisestage oma e-posti aadress',
  enter_email_placeholder_email: 'Meil',
  enter_email_button_enter: 'Sisestage',
  components_login_success_text: 'Sisselogimine õnnestus!',
  components_card_link_media_content: 'Kuulake kohe',
  components_card_link_text1_content: 'Vaata juhendit',
  components_card_link_text2_content: 'Uurige',
  france: 'Prantsusmaa',
  cyprus: 'Küpros',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditatsioon',
  page_media_content_menu_all: 'Kõik',
};